<h2 class="e-content-heading">{{ categoryDefinitions.name }}</h2>

<div *ngFor="let definition of categoryDefinitions.definitions; trackBy: trackDefinitions">
    <h3 class="e-definition-title" [id]="definition.selector">
        {{ definition.title }}
    </h3>
    <div class="e-definition-content" [innerHTML]="definition.description"></div>
</div>
